import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AbstractService } from "src/app/common/services/abstract.service";

const API_PATH = "/api/internal/prompts";

@Injectable({
  providedIn: "root",
})
export class PromptTrackingService extends AbstractService {
  private readonly httpClient = inject(HttpClient);

  async countPromptTrackingGroupByDate(params: HttpParams): Promise<Record<string, number> | null> {
    return await this.cancelPrevious(
      "count-trackings-group-by-date",
      this.httpClient.get<Record<string, number>>(`${API_PATH}/count-trackings-group-by-date`, { params }),
    );
  }

  async countMostUsedPrompts(params: HttpParams): Promise<Record<string, number> | null> {
    return await this.cancelPrevious(
      "count-most-used",
      this.httpClient.get<Record<string, number>>(`${API_PATH}/count-most-used`, { params }),
    );
  }

  async trackPrompt(promptId: string): Promise<void> {
    await this.cancelPrevious("track-prompt", this.httpClient.post(`${API_PATH}/track-prompt/${promptId}`, ""));
  }
}
